import { TeamRoleBase } from './base/team-role-base';

export class TeamRole extends TeamRoleBase { }